import { render } from "./BlogInLaysBenefits.vue?vue&type=template&id=fb04ec78"
import script from "./BlogInLaysBenefits.vue?vue&type=script&lang=js"
export * from "./BlogInLaysBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__